import { Users } from '@omnea-app/packages/universal/hasura/graphql'
import { InitialsAvatar, InitialsAvatarProps } from './InitialsAvatar'

interface Props extends Pick<InitialsAvatarProps, 'size' | 'sx'> {
  user: Pick<Users, 'id' | 'firstName' | 'lastName'>
}

export const LoggedInUserAvatar: React.FC<Props> = ({ user, ...rest }) => {
  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`
  return <InitialsAvatar fullName={name} {...rest} />
}

interface UserAvatarProps extends Pick<InitialsAvatarProps, 'size' | 'sx'> {
  user: Pick<Users, 'id' | 'firstName' | 'lastName' | 'isArchived'>
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ user, sx, ...rest }) => {
  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`

  return <InitialsAvatar fullName={name} {...rest} sx={{ ...sx, ...(user.isArchived && { bgcolor: 'neutral.light.500' }) }} />
}
